import { render } from "./appView.vue?vue&type=template&id=73c992fd&scoped=true"
const script = {}

import "./appView.vue?vue&type=style&index=0&id=73c992fd&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73c992fd"]])

export default __exports__